import { render, staticRenderFns } from "./submit-answer-sheet-dialog.vue?vue&type=template&id=a0ce8f54&scoped=true"
import script from "./submit-answer-sheet-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./submit-answer-sheet-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./submit-answer-sheet-dialog.vue?vue&type=style&index=0&id=a0ce8f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ce8f54",
  null
  
)

export default component.exports